module.exports = __webpack_public_path__ + "static/media/off-road-truck.b564f48f.png";